import {
  Church, Wine, UtensilsCrossed, Music, PartyPopper,
  Sparkles, Camera, Heart, Gem, Clock, Rocket, Star,
} from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

// Además de los iconos del contrato, esta plantilla suma "cohete" y "estrella".
const ICONOS = {
  iglesia: Church,
  copas: Wine,
  cena: UtensilsCrossed,
  musica: Music,
  fiesta: PartyPopper,
  brillo: Sparkles,
  camara: Camera,
  corazon: Heart,
  anillos: Gem,
  reloj: Clock,
  cohete: Rocket,
  estrella: Star,
};

export default function Itinerario({ datos, seccion }) {
  const items = datos.itinerario || [];
  if (items.length === 0) return null;

  return (
    <section className="kx-seccion" aria-label={seccion.titulo}>
      <div className="kx-seccion-interior">
        <EncabezadoSeccion p="kx" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="kx-titulo-itinerario" />
        <Reveal>
          <ul className="kx-itinerario">
            {items.map((item, i) => {
              const Icono = ICONOS[item.icono] || Clock;
              return (
                <li className="kx-itinerario-item" key={i} data-testid={`kx-itinerario-item-${i}`}>
                  <span className={`kx-itinerario-icono kx-itinerario-icono--${(i % 3) + 1}`}>
                    <Icono strokeWidth={2} />
                  </span>
                  <div>
                    <p className="kx-itinerario-hora">{item.hora}</p>
                    <h3 className="kx-itinerario-titulo">{item.titulo}</h3>
                    {item.descripcion && <p className="kx-itinerario-desc">{item.descripcion}</p>}
                  </div>
                </li>
              );
            })}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
